import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './dishListMenuItemWithReviewsQuery.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type DishListMenuItemWithReviewsQuery_dishList_DishList_menuItem_MenuItem_paginatedReviews_ReviewPaginationHandler_records_Review = {
  __typename: 'Review',
  id: number,
  content?: string | null,
  createdAt?: string | null,
  reviewUpvotesCount?: number | null,
  userAvatarUrl: string,
  userDisplayName: string
};

export type DishListMenuItemWithReviewsQuery_dishList_DishList_menuItem_MenuItem_paginatedReviews_ReviewPaginationHandler = {
  __typename: 'ReviewPaginationHandler',
  count: number,
  hasMore: boolean,
  offset: number,
  records: Array<DishListMenuItemWithReviewsQuery_dishList_DishList_menuItem_MenuItem_paginatedReviews_ReviewPaginationHandler_records_Review>
};

export type DishListMenuItemWithReviewsQuery_dishList_DishList_menuItem_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  paginatedReviews: DishListMenuItemWithReviewsQuery_dishList_DishList_menuItem_MenuItem_paginatedReviews_ReviewPaginationHandler
};

export type DishListMenuItemWithReviewsQuery_dishList_DishList = {
  __typename: 'DishList',
  id: number,
  menuItem?: DishListMenuItemWithReviewsQuery_dishList_DishList_menuItem_MenuItem | null
};

export type DishListMenuItemWithReviewsQuery_Query = {
  __typename?: 'Query',
  dishList: DishListMenuItemWithReviewsQuery_dishList_DishList
};


export type DishListMenuItemWithReviewsQueryVariables = Types.Exact<{
  dishListSlug: Types.Scalars['String']['input'];
  menuItemId: Types.Scalars['Int']['input'];
  approved?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type DishListMenuItemWithReviewsQuery = DishListMenuItemWithReviewsQuery_Query;


export const DishListMenuItemWithReviewsDocument = /*#__PURE__*/ document as unknown as DocumentNode<DishListMenuItemWithReviewsQuery, DishListMenuItemWithReviewsQueryVariables>;


/**
 * __useDishListMenuItemWithReviewsQuery__
 *
 * To run a query within a React component, call `useDishListMenuItemWithReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDishListMenuItemWithReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDishListMenuItemWithReviewsQuery({
 *   variables: {
 *      dishListSlug: // value for 'dishListSlug'
 *      menuItemId: // value for 'menuItemId'
 *      approved: // value for 'approved'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useDishListMenuItemWithReviewsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DishListMenuItemWithReviewsQuery, DishListMenuItemWithReviewsQueryVariables> & ({ variables: DishListMenuItemWithReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DishListMenuItemWithReviewsQuery, DishListMenuItemWithReviewsQueryVariables>(DishListMenuItemWithReviewsDocument, options);
      }
export function useDishListMenuItemWithReviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DishListMenuItemWithReviewsQuery, DishListMenuItemWithReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DishListMenuItemWithReviewsQuery, DishListMenuItemWithReviewsQueryVariables>(DishListMenuItemWithReviewsDocument, options);
        }
// @ts-ignore
export function useDishListMenuItemWithReviewsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DishListMenuItemWithReviewsQuery, DishListMenuItemWithReviewsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DishListMenuItemWithReviewsQuery, DishListMenuItemWithReviewsQueryVariables>;
export function useDishListMenuItemWithReviewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DishListMenuItemWithReviewsQuery, DishListMenuItemWithReviewsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DishListMenuItemWithReviewsQuery | undefined, DishListMenuItemWithReviewsQueryVariables>;
export function useDishListMenuItemWithReviewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DishListMenuItemWithReviewsQuery, DishListMenuItemWithReviewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DishListMenuItemWithReviewsQuery, DishListMenuItemWithReviewsQueryVariables>(DishListMenuItemWithReviewsDocument, options);
        }
export type DishListMenuItemWithReviewsQueryHookResult = ReturnType<typeof useDishListMenuItemWithReviewsQuery>;
export type DishListMenuItemWithReviewsLazyQueryHookResult = ReturnType<typeof useDishListMenuItemWithReviewsLazyQuery>;
export type DishListMenuItemWithReviewsSuspenseQueryHookResult = ReturnType<typeof useDishListMenuItemWithReviewsSuspenseQuery>;
export type DishListMenuItemWithReviewsQueryResult = ApolloReactCommon.QueryResult<DishListMenuItemWithReviewsQuery, DishListMenuItemWithReviewsQueryVariables>;